module.exports =
  'actions_empty': require './actions_empty'
  'ad_business_class': require './ad_business_class'
  'ad_business_class_google_apps': require './ad_business_class_google_apps'
  'archived_card_options': require './archived_card_options'
  'archived_cards': require './archived_cards'
  'archived_lists': require './archived_lists'
  'atMention': require './atMention'
  'attachment_viewer': require './attachment_viewer'
  'attachment_viewer_frame': require './attachment_viewer_frame'
  'attachment_viewer_frame_details': require './attachment_viewer_frame_details'
  'avatar_change': require './avatar_change'
  'badge': require './badge'
  'board': require './board'
  'board_archive': require './board_archive'
  'board_background_options': require './board_background_options'
  'board_background_selection': require './board_background_selection'
  'board_change_background': require './board_change_background'
  'board_desc': require './board_desc'
  'board_header': require './board_header'
  'board_header_permissions': require './board_header_permissions'
  'board_member_profile': require './board_member_profile'
  'board_menu_activity': require './board_menu_activity'
  'board_menu_commenting': require './board_menu_commenting'
  'board_menu_default': require './board_menu_default'
  'board_menu_invitations': require './board_menu_invitations'
  'board_menu_more': require './board_menu_more'
  'board_menu_more_activity_button': require './board_menu_more_activity_button'
  'board_menu_settings': require './board_menu_settings'
  'board_menu_subscribed_state': require './board_menu_subscribed_state'
  'board_menu_vis': require './board_menu_vis'
  'board_new': require './board_new'
  'board_new_vis': require './board_new_vis'
  'board_observer_count': require './board_observer_count'
  'boards_page_add_org_button': require './boards_page_add_org_button'
  'calendar_day': require './calendar_day'
  'calendar_day_list_header': require './calendar_day_list_header'
  'calendar_month': require './calendar_month'
  'calendar_toolbar': require './calendar_toolbar'
  'calendar_week': require './calendar_week'
  'cant_add_board_to_org': require './cant_add_board_to_org'
  'card_composer_inline': require './card_composer_inline'
  'card_copy': require './card_copy'
  'card_detail_more_menu': require './card_detail_more_menu'
  'card_menu_meta': require './card_menu_meta'
  'card_title_on_card_front': require './card_title_on_card_front'
  'change_org_vis': require './change_org_vis'
  'checklist': require './checklist'
  'checklist_add_menu': require './checklist_add_menu'
  'checklist_item': require './checklist_item'
  'closed_boards': require './closed_boards'
  'comment_edit_controls': require './comment_edit_controls'
  'confirm': require './confirm'
  'confirm_merge': require './confirm_merge'
  'connect_failed': require './connect_failed'
  'crop_photo': require './crop_photo'
  'dialog_close_button': require './dialog_close_button'
  'edit_controls': require './edit_controls'
  'embedly': require './embedly'
  'error': require './error'
  'filter_cards': require './filter_cards'
  'filter_cards_search_results': require './filter_cards_search_results'
  'formatting_help': require './formatting_help'
  'header_add_menu': require './header_add_menu'
  'header_back_menu_button': require './header_back_menu_button'
  'header_boards_menu_button': require './header_boards_menu_button'
  'header_logo': require './header_logo'
  'header_overdue_banner': require './header_overdue_banner'
  'header_promo_nav': require './header_promo_nav'
  'header_public_board': require './header_public_board'
  'header_search': require './header_search'
  'header_signup_login': require './header_signup_login'
  'header_two_factor_backups_banner': require './header_two_factor_backups_banner'
  'header_user': require './header_user'
  'header_version_picker': require './header_version_picker'
  'header_warning_banner': require './header_warning_banner'
  'header_warning_password': require './header_warning_password'
  'index': require './index'
  'invitation': require './invitation'
  'kiln_changeset_preview': require './kiln_changeset_preview'
  'kiln_changeset_thumbnail': require './kiln_changeset_thumbnail'
  'label_edit_component': require './label_edit_component'
  'label_limit_exceeded': require './label_limit_exceeded'
  'list': require './list'
  'list_bulk_card_move': require './list_bulk_card_move'
  'list_copy': require './list_copy'
  'manage_members_select_role': require './manage_members_select_role'
  'member_account': require './member_account'
  'member_application': require './member_application'
  'member_application_list': require './member_application_list'
  'member_billing_org_link': require './member_billing_org_link'
  'member_billing_org_link_list': require './member_billing_org_link_list'
  'member_boards_list_ad': require './member_boards_list_ad'
  'member_cards_card': require './member_cards_card'
  'member_cards_date': require './member_cards_date'
  'member_detail_profile_edit': require './member_detail_profile_edit'
  'member_detail_profile_info': require './member_detail_profile_info'
  'member_gold_earned': require './member_gold_earned'
  'member_inline': require './member_inline'
  'member_list_item_detail': require './member_list_item_detail'
  'member_login': require './member_login'
  'member_on_board_menu': require './member_on_board_menu'
  'member_on_card_menu': require './member_on_card_menu'
  'member_profile': require './member_profile'
  'member_profile_info': require './member_profile_info'
  'member_session': require './member_session'
  'member_session_list': require './member_session_list'
  'members_voted': require './members_voted'
  'menu': require './menu'
  'menu_base': require './menu_base'
  'move_card_controls': require './move_card_controls'
  'observer_list': require './observer_list'
  'org_boards_for_member': require './org_boards_for_member'
  'org_create': require './org_create'
  'org_detail_profile_edit': require './org_detail_profile_edit'
  'org_detail_profile_info': require './org_detail_profile_info'
  'org_export': require './org_export'
  'org_export_empty': require './org_export_empty'
  'org_export_item': require './org_export_item'
  'org_link_ga_helper': require './org_link_ga_helper'
  'org_member_activity': require './org_member_activity'
  'org_pref_restriction': require './org_pref_restriction'
  'org_prefs_nonorg_invites': require './org_prefs_nonorg_invites'
  'org_prefs_vis': require './org_prefs_vis'
  'org_remove_or_deactivate_member': require './org_remove_or_deactivate_member'
  'organization_list_item': require './organization_list_item'
  'organization_search_list_item': require './organization_search_list_item'
  'plugin_chrome': require './plugin_chrome'
  'pop_over_ad': require './pop_over_ad'
  'popover_add_board_to_org': require './popover_add_board_to_org'
  'popover_add_email': require './popover_add_email'
  'popover_add_to_team': require './popover_add_to_team'
  'popover_auto_mentioner': require './popover_auto_mentioner'
  'popover_board_header_org_menu': require './popover_board_header_org_menu'
  'popover_card_from_calendar': require './popover_card_from_calendar'
  'popover_change_board_org': require './popover_change_board_org'
  'popover_change_labels': require './popover_change_labels'
  'popover_change_roles': require './popover_change_roles'
  'popover_change_set_password': require './popover_change_set_password'
  'popover_change_user_info': require './popover_change_user_info'
  'popover_confirm_member_delete': require './popover_confirm_member_delete'
  'popover_emoji_completer': require './popover_emoji_completer'
  'popover_emoji_uploader': require './popover_emoji_uploader'
  'popover_filter_pos_results': require './popover_filter_pos_results'
  'popover_helper_new_board_add_org': require './popover_helper_new_board_add_org'
  'popover_insertion_menu': require './popover_insertion_menu'
  'popover_member_searcher': require './popover_member_searcher'
  'popover_move_card': require './popover_move_card'
  'popover_org_logo': require './popover_org_logo'
  'popover_rename_board': require './popover_rename_board'
  'popover_select_members': require './popover_select_members'
  'popover_selector_menu': require './popover_selector_menu'
  'popover_set_email_freq': require './popover_set_email_freq'
  'popover_share': require './popover_share'
  'power_up_item': require './power_up_item'
  'power_up_item_details': require './power_up_item_details'
  'power_ups_about_calendar': require './power_ups_about_calendar'
  'power_ups_about_card_aging': require './power_ups_about_card_aging'
  'power_ups_about_voting': require './power_ups_about_voting'
  'power_ups_detail_navbar': require './power_ups_detail_navbar'
  'product_promo_button': require './product_promo_button'
  'quick_card_editor': require './quick_card_editor'
  'saved_search': require './saved_search'
  'search_results_card': require './search_results_card'
  'search_suggetion': require './search_suggetion'
  'search_suggetion_board': require './search_suggetion_board'
  'search_suggetion_member': require './search_suggetion_member'
  'select_emoji': require './select_emoji'
  'select_labels': require './select_labels'
  'select_member': require './select_member'
  'select_org_to_upgrade': require './select_org_to_upgrade'
  'shortcuts': require './shortcuts'
  'sticker_on_card': require './sticker_on_card'
  'sticker_pack_selection_list': require './sticker_pack_selection_list'
  'sticker_select': require './sticker_select'
  'sticker_select_item': require './sticker_select_item'
  'sticker_select_item_upload': require './sticker_select_item_upload'
  'sync_error': require './sync_error'
  'take_photo': require './take_photo'
  'tooltip_content': require './tooltip_content'
  'woof_header': require './woof_header'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/index.coffee